<div class="flex flex-col h-full w-full overflow-hidden">
  <!-- Header -->
  <div class="flex justify-between items-center p-4 h-auto">
    <!-- Logo -->
    <div class="w-30 h-auto">
        <img class="w-90 h-auto" src="images/logo/logo.svg" />
    </div>

    <!-- Close button -->
    <!-- <button mat-icon-button mat-dialog-close (click)="closeDialog()" class="icon-size-2" *ngIf="shouldShowCloseButton()">
        <mat-icon>close</mat-icon>
    </button> -->
    
  </div>

  <!-- Main Content - Enhanced for better space distribution -->
  <div class="flex-grow flex flex-col h-full px-4 sm:px-6">
    <!-- Top section with title and text -->
    <div class="flex flex-col items-center justify-center w-full pt-10 sm:pt-14 mb-2 sm:mb-6">
      <h1 class="text-3xl sm:text-3xl font-extrabold leading-tight text-center">
        {{ 'unauthorized.blockedusertext' | transloco }}
      </h1>
      
    </div>
    
    <!-- Bottom section with button and text -->
    <div class="w-full max-w-md mx-auto mt-auto pb-6 sm:pb-8">
      <button 
        (click)="closeDialog()"
        class="w-full my-button py-4 text-white rounded-full font-semibold text-base md:text-base transition h-14 shadow btnactions-base bg-teal-700 hover:bg-teal-800"
      >
      {{'general.close' | transloco}}
      </button>
      <p class="text-base mt-3 text-center">
        {{ 'unauthorized.blockedUserSuggerence' | transloco }} <br>
        <a [href]="'mailto:' + contactEmail" class="text-[#006E75] hover:text-[#003E42] hover:underline cursor-pointer">
          {{ 'unauthorized.blockedUsercontact' | transloco }}
        </a>
      </p>
    </div>
  </div>
</div>